import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface PageLayoutProps {
  children: ReactNode;
  /** Footer content — pass `false` to hide footer entirely */
  footer?: ReactNode | false;
  /** Background utility class: 'bg-grid-pattern', 'bg-dot-pattern', 'bg-gradient-spotlight', etc. */
  background?: string;
  /** Full-bleed mode removes the container constraint (useful for landing pages) */
  fullBleed?: boolean;
  className?: string;
}

export function PageLayout({
  children,
  footer,
  background = '',
  fullBleed = false,
  className = '',
}: PageLayoutProps) {
  return (
    <div className={`min-h-screen flex flex-col ${background} ${className}`}>
      {/* ── Main content ── */}
      <main className='flex-1 relative'>
        {fullBleed ? children : (
          <div className='container py-8'>
            {children}
          </div>
        )}
      </main>

      {/* ── Footer ── */}
      {footer !== false && (
        <footer className='relative border-t border-border/30'>
          <div className='absolute inset-0 pointer-events-none' />
          <div className='relative container py-8'>
            {footer || (
              <div className='flex flex-col items-center gap-2'>
                <p className='text-center text-xs text-muted-foreground/60'>
                  &copy; {new Date().getFullYear()} Danger Dan!
                </p>
                <div className='flex items-center gap-4'>
                  <Link
                    to='/terms'
                    className='text-xs transition-colors duration-200'
                    style={{ color: 'rgba(255,255,255,0.35)' }}
                    onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(124,252,0,0.7)'; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.35)'; }}
                  >
                    Terms of Service
                  </Link>
                  <span style={{ color: 'rgba(255,255,255,0.15)', fontSize: '0.6rem' }}>&bull;</span>
                  <Link
                    to='/privacy'
                    className='text-xs transition-colors duration-200'
                    style={{ color: 'rgba(255,255,255,0.35)' }}
                    onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(124,252,0,0.7)'; }}
                    onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'rgba(255,255,255,0.35)'; }}
                  >
                    Privacy Policy
                  </Link>
                </div>
              </div>
            )}
          </div>
        </footer>
      )}
    </div>
  );
}
